import {
  inboundShipmentIdFormat,
  locationIdFormat,
} from "@redotech/redo-inventory-id";
import * as z from "zod";

export const bulkUpdateShipments = {
  name: "bulkUpdateShipments" as const,
  input: z.object({
    inboundShipmentIds: z.array(inboundShipmentIdFormat.schema),
    destinationId: locationIdFormat.schema.optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
